import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ProfileService } from '../profile/profile.service';
import { NotificationBuilder } from '../shared/notificationBuilder';
import { HelperService } from '../services/helper.service';
import { forkJoin, Observable } from 'rxjs';
import { Customization, CustomizationCauseIcons, CauseIcon } from '../models/customization.model';
import { SupportedNgo } from '../models/store.model';
import { NgoService } from '../ngo/ngo.service';
import { Cause } from '../models/ngo.model';
import { CausesService } from '../causes/causes.service';
import { Profile } from '../models/profile.model';
import { Lead } from '../models/lead';

declare var jQuery: any

@Component({
  selector: 'app-customization',
  templateUrl: './customization.component.html',
  styleUrls: ['./customization.component.css']
})

export class CustomizationComponent implements OnInit {
  loading: boolean
  customize: Customization
  icons: any
  showExample: boolean = true
  lead = new Lead();
  selectedCause: Cause[] = new Array<Cause>();
  showPopup: boolean = false;
  hasChanges: boolean = false;
  ngoChangeList: any;
  modalType: string;
  isNewCostumer: boolean = false;
  redirectDomain:string;

  @Output() answer = new EventEmitter();
  causes: Cause[];
  causesCampaign: Cause[];
  selectedCauses: string[] = new Array<string>();
  maxCauses: number = 2;
  profile: Profile;
  typeDonationValue: boolean = false;
  changeDonation: boolean;
  hasRoundupEnable: boolean;
  storePlatform: any;
  isAdmin: boolean;
  hover = [false, false, false];
  selectedBox = [false, false, false];
  activeNgos:  Cause[];
  selectedNgo: any;
  category: string;
  hideOngs: boolean = false;
  
  constructor(private profileService: ProfileService, 
    private ngoService: NgoService,  
    private notificationBuilder: NotificationBuilder) {
  }

  ngOnInit() {
    /*MVP para que o popup apareça apenas na primeira vez, mas se limpar o cache aparece de novo*/
    this.isNewCostumer = localStorage.getItem('isNew') == null;
    if(this.isNewCostumer){
      localStorage.setItem('isNew', 'false');
      this.isNewCostumer = true;
    }

    this.profileService.getCurrentUserInfo().subscribe(data => {
      this.profile = data;
      console.log(this.profile);
      this.isAdmin = localStorage.getItem("admin-token") != null;
      this.storePlatform = localStorage.getItem("storePlatform");
      this.redirectDomain = "https://"+this.profile.domain.split(',')[0];

      if (this.storePlatform != null && this.storePlatform.indexOf('stone') >= 0 && this.storePlatform.indexOf('menuintegrado') >= 0) {
        this.hasRoundupEnable = true;
      }

      this.requestDataFromMultipleSources().subscribe(([getCustomization, getCauseIcons, getCauses, getMyCauses]) => {
        this.customize = getCustomization
        if (getCauseIcons.success) {
          this.customize.causeIcons = new CustomizationCauseIcons()
          this.customize.causeIcons.icons = getCauseIcons.data.icons
          this.customize.causeIcons.ngos = getCauseIcons.data.ngos
        }

        //seta qual eh o maximo de causas que essa loja pode apoiar dependendo do plano dela
        var plan = this.profile.planSeoName;
        var text = "o seu plano só da suporte a no máximo 2 causas.";
        if (plan.indexOf('3') > 0 || plan.indexOf('4') > 0 || plan.indexOf('5') > 0 || plan.indexOf('6') > 0 || plan.indexOf('7') > 0 || plan.indexOf('percentual') >= 0) {
          this.maxCauses = 3;
        }

        //adiciona as causas ativas que estao sendo apoiadas
        if (getMyCauses) {
          getMyCauses.forEach(element => {
            if (element.active)
              this.selectedCauses.push(element.friendlyUrl);
          });
          this.getActiveNgos(getMyCauses);
        }

        //adiciona a lista de causas disponível para apoiar com o Polen
        if (getCauses !== null) {
          getCauses.forEach(c => {
            c.imageThumb = c.imageThumb.replace('-1.svg', '-3.svg');
          });
          this.causes = getCauses;
        }
      })
    });
  }

  selectExampleCause(friendlyUrl) {
    this.causes.forEach(element => {
      element.isSelectedExample = false;
    });

    this.selectedCause.find(x => x.friendlyUrl == friendlyUrl).isSelectedExample = true;
  }

  requestDataFromMultipleSources(): Observable<any[]> {
    let getAbTests = this.profileService.getCustomizeAbTests()
    let getCauseIcons = this.profileService.getCustomizeCauseIcons()
    let getCauses = this.ngoService.getCauses()
    let getMyCauses = this.ngoService.getSupportedNgo()
    return forkJoin([getAbTests, getCauseIcons, getCauses, getMyCauses]);
  }

  causesExist(): boolean {
    let response = false;
    this.causes.forEach(cause => {
      if (cause.isSelected === true) {
        response = true;
        this.selectedCause.push(cause);
      }
    })
    return response
  }

  getCausesCampaign(campaign) {
    this.selectedCauses = [];
    this.ngoService.getCausesCampaign(campaign).subscribe(data => {
      if (data != null)
        this.causesCampaign = data;
    })
  }

  saveCustomization(abTest) {
    this.loading = true
    debugger
    this.profileService.updateAbTestCustomization(abTest).subscribe(data => {
      this.loading = false
      if (data) {
        this.profileService.clearStoreCache(this.customize.storeSeoName).subscribe()
        this.notificationBuilder.showNotification('success', 1000, 'Seus dados foram alterados com sucesso', 'bottom', 'left')
      } else {
        this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a alteração dos seus dados', 'bottom', 'left')
      }
    })
  }

  // INICIA SESSAO DE MUDANCA DE ICONES
  changeIcon(icon: CauseIcon, ngo: SupportedNgo) {
    this.customize.causeIcons.ngos.forEach(cause => {
      if (cause.url == ngo.url) {
        cause.logo = icon.logo
      }
    });
  }

  saveCauseIcons() {
    this.loading = true
    debugger
    this.profileService.updateCauseIcons(this.customize.causeIcons.ngos).subscribe(data => {
      this.loading = false
      if (data) {
        this.fullClearCache();
        this.notificationBuilder.showNotification('success', 1000, 'Seus dados foram alterados com sucesso', 'bottom', 'left')
        window.location.reload();
      } else {
        this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a alteração dos seus dados', 'bottom', 'left')
      }
    })
  }
  // FIM SESSAO DE MUDANCA DE ICONES

  changeDonationRule(rule) {
    this.changeDonation = true;
    this.profile.donationRule = rule
  }

  changeDonationType(type) {
    this.changeDonation = true;
    this.profile.donationType = type
  }
  
  changeDonationValue(value) {
    this.typeDonationValue = false;
    this.changeDonation = true;
    this.profile.donationValue = value
  }

  changeOngAnswer(listOngs: any) {
    this.ngoChangeList = listOngs; 
    this.hasChanges = true;
  }

  changeSelectedCause(ngo){
    this.selectedNgo = ngo;
    console.log(this.selectedNgo);
  }

  fullClearCache(){
    this.profileService.clearStoreApiCache(this.customize.storeSeoName);
    this.profileService.clearStoreCache(this.customize.storeSeoName);
  }

  getActiveNgos(causes){
    this.activeNgos = new Array();
    causes.forEach(element => {
      if (element.active)
        this.activeNgos.push(element);
    });
    console.log(this.activeNgos);
  }

  openPopup(type){
    this.showPopup = true;
    this.modalType = type;
  }
  
  saveChangesNgos(){
    this.loading = true;
    this.ngoService.changeNgoByUser(this.profile.storeSeoName, this.ngoChangeList.selectedCauses, null, this.isAdmin).subscribe(data => {
      debugger
      if(data.success){
        this.profileService.clearStoreCache(this.profile.storeSeoName)
        window.location.reload();
        this.loading = false
      }else{
        this.notificationBuilder.showNotification('danger', 1000, data.error, 'bottom', 'left')
      }
    })
  }

  saveCustomNgos(){
    this.ngoChangeList = jQuery("#customChange").val();
    this.ngoChangeList = this.ngoChangeList.split(",");
    this.ngoService.changeNgoByUser(this.profile.storeSeoName, this.ngoChangeList, null, this.isAdmin).subscribe(data => {
      debugger
      if(data.success){
        this.profileService.clearStoreCache(this.profile.storeSeoName)
        window.location.reload();
        this.loading = false
      }else{
        this.notificationBuilder.showNotification('danger', 1000, data.error, 'bottom', 'left')
      }
    })
  }

  saveNgoInCause(){
    this.loading = true;
    debugger
    this.ngoService.changeNgoByUser(this.profile.storeSeoName, this.ngoChangeList.selectedCauses, this.category, this.isAdmin).subscribe(data => {
      debugger
      if(data.success){
        this.profileService.clearStoreCache(this.profile.storeSeoName)
        window.location.reload();
        this.loading = false;
      }else{
        this.notificationBuilder.showNotification('danger', 1000, data.error, 'bottom', 'left')
      }
    })
  }

  saveProfile() {
    debugger
    this.loading = true

    var donationValueValidation = this.validateDonationValue(this.profile);
    if (donationValueValidation) {
      this.loading = false
      this.notificationBuilder.showNotification('danger', 1000, donationValueValidation, 'bottom', 'left')
      return
    }

    if (!this.profile.scriptValidated && this.profile.integrationActive) {
      this.loading = false
      this.notificationBuilder.showNotification('danger', 1000, 'Para ativarmos sua loja, você precisa estar com o script inserido na sua loja. Veja mais no menu SETUP.', 'bottom', 'left')
      return
    }

    if(!this.profile.activePayingUser && this.profile.planSeoName=="free"){
      this.loading = false
      this.notificationBuilder.showNotification('danger', 1000, 'Para ativarmos sua loja, você precisa recarregar os seus créditos. Veja mais no menu "Adicionar Créditos".', 'bottom', 'left')
      this.profile.integrationActive = false;
      return
    }

    this.profileService.updateProfile(this.profile).subscribe(data => {
      this.loading = false
      if (data) {
        this.profileService.clearStoreCache(this.profile.storeSeoName).subscribe()
        
        this.loading = true;
        
        this.fullClearCache();

        this.notificationBuilder.showNotification('success', 1000, 'Seus dados foram alterados com sucesso', 'bottom', 'left')

        setTimeout(()=>{
          window.location.reload();
        },1500)

      } else {
        this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a alteração dos seus dados', 'bottom', 'left')
      }
    })
  }

  typeOtherDonationValue() {
    this.typeDonationValue = true;
    this.changeDonation = true;
  }

  updateCausesChoice(step: string, form: any) {
    var seoUrl = this.profile.storeSeoName
    this.selectedCause = [];
    if (step == 'cause') {
      this.answer.emit({
        "selectedCauses": form.selectedCauses,
      });
      this.ngoService.changeNgosOfStore(this.profile.storeSeoName, form.selectedCauses).subscribe(data => {
        debugger
        this.profileService.clearStoreCache(this.profile.storeSeoName)
        window.location.reload();
        this.loading = false
      })
    }
  }

  validateDonationValue(model: Profile) {
    if (model.donationType == 0) {
      if (model.donationValue <= 0) {
        return "O valor da doação precisa ser maior que zero"
      }
    } else {
      if (model.donationValue <= 0 || model.donationValue > 100) {
        return "O valor da doação precisa estar entre 1% e 100%"
      }
    }

    return null
  }

  verifySelected(selectedBox: boolean, position: number) {
    if (selectedBox === true) {
      for (let i = 0; i < this.hover.length; i++) {
        this.hover[i] = false;
        this.selectedBox[i] = false;
      }
      this.hover[position] = true;
      this.selectedBox[position] = true;
    }
    else {
      this.hover[position] = false;
    }
  }

}

